// redux/slices/taskSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { taskReducer } from "../Reducer/taskReducer";

const initialState = {
    loading: false,
    tasks: [],
    taskUser: {
        firstname: "",
        lastname: "",
        email: "",
        userId: "",
    },
    calendarTasks: [],
    calendarLeaveByDate: {},
    calendarPublicHolidaysByDate: {},
    error: null,
    isTaskUpdated: false,
    workingHours: {
        loading: true,
        data: null
    },
    filteredTasks: {},
};

const taskSlice = createSlice({
    name: "task",
    initialState,
    reducers: {
        addTask:(state,action)=>{
            const dateKey = action.payload?.date;
            const payload = action.payload?.payload;
            if (!dateKey) return;
            state.calendarTasks[dateKey] = payload;
        }
        // Add any synchronous actions here if needed
    },
    extraReducers: (builder) => {
        taskReducer(builder);
    },
});

export const { addTask} = taskSlice.actions;
export default taskSlice.reducer; 